// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__3bFZZ","active":"Dropdown_active__20G_P","head":"Dropdown_head__36HSf","body":"Dropdown_body__LT3Z_","link":"Dropdown_link__3bI4l"};